import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { getFastlyImageFromAbsoluteImageUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";

const ImperfectionPartSliderCard = ({key, item, handleImageClickCallback, index, isModal}) => {
    const {iconUrl = "", imageUrl, subTitle, title} = item || {};
    const handleImageClick = () => {
        handleImageClickCallback(item, index);
    };
    return (
        <div key={key} styleName={`styles.outer ${isModal ? "styles.modalOuter" : ""}`}>
            <img src={getFastlyImageFromAbsoluteImageUrl(imageUrl, imageTypes.imperfectionMobileSliderImage)} alt="Car image" onClick={handleImageClick} />
            <div styleName={"styles.bottomContainer"}>
                {!isModal && <img src={iconUrl} alt="Car panel image" height="38px" />}
                <div styleName={"styles.panelWrapper"}>
                    <p styleName={"styles.heading"}>{title}</p>
                    <p styleName={"styles.subHeading"}>{subTitle}</p>
                </div>
                {isModal && <img src={iconUrl} alt="Car panel image" height="38px" />}
            </div>
        </div>
    );
};
ImperfectionPartSliderCard.propTypes = {
    item: PropTypes.object,
    key: PropTypes.array,
    handleImageClickCallback: PropTypes.func,
    openModalCallback: PropTypes.func,
    index: PropTypes.number,
    isModal: PropTypes.bool
};

export default ImperfectionPartSliderCard;
